export default "//yastatic.net/s3/distribution/pythia/frontend/_/07a0c403c30d5e17e546f6f1807a9edf.jpeg";